import { Link } from 'react-router-dom';
import { Download } from 'lucide-react';
import { haptics } from '../../../utils/haptics';

const secondaryButtonClasses =
  'inline-flex items-center justify-center font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-offset-2 touch-target bg-gray-200 dark:bg-white/10 dark:backdrop-blur-sm dark:border dark:border-white/15 text-gray-900 dark:text-gray-100 hover:bg-gray-300 dark:hover:bg-white/20 dark:hover:border-white/25';

const sizeClasses = {
  md: 'px-4 py-2 text-body-sm squircle-sm',
  lg: 'px-6 py-3 text-body squircle',
};

export default function DownloadStationLink({ size = 'md', testId }) {
  return (
    <Link
      to="/download"
      onClick={() => haptics.light()}
      data-testid={testId}
      className={`${secondaryButtonClasses} ${sizeClasses[size]}`}
    >
      <Download className="w-5 h-5 mr-2" aria-hidden="true" />
      Download Media Station
    </Link>
  );
}
